import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeOligonYpsili';
const args = {};

export class ModeOligonYpsili extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
